export default "__VITE_ASSET__CVjWcuRn__"